import { useEffect, useState } from "react";
import { FormikProvider, useFormik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
import { config } from "../../CommonUtils/CommonURLS";
import { CommonAxiosGet, CommonAxiosPut } from "../../CommonUtils/CommonAxios";

export default function CommiteRecmndations() {
  const [trustData, setTrustData] = useState([]);

  // Initial Values
  const initialValues = {
    recommended: "",
  };

  // Validation
  const validationSchema = Yup.object({
    recommended: Yup.string().required("Required"),
  });

  // Formik
  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values) => {
      Swal.fire({
        title: "Are you sure?",
        text: "Do you want to submit?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Yes, Submit",
      }).then((result) => {
        if (result.isConfirmed) {
          //Payload must match backend field name
          const payload = {
            recommendedStatus: values.recommended,
          };
          let url = config.url.FAC_URL + "updateRecommendedStatus";
          CommonAxiosPut(url, payload).then((res) => {
            if (res?.data?.scode === "01") {
              Swal.fire("Success", "Updated Successfully", "success").then(
                () => {
                  //reload updated data
                  getTrustData();
                },
              );
            } else {
              Swal.fire("Error", "Failed to Update", "error");
            }
          });
        }
      });
    },
  });

  // GET
  function getTrustData() {
    let trustUrl = config.url.FAC_URL + "getSocietyNameChange";
    CommonAxiosGet(trustUrl).then((res) => {
      if (res?.data?.scode === "01") {
        setTrustData(res.data.societyName);
        formik.setFieldValue(
          "recommended",
          res.data.societyName[0].recommended_status || "",
        );
      }
    });
  }
  useEffect(() => {
    getTrustData();
  }, []);
  return (
    <>
      <div className="faculty-form-wrapper">
        <div className="faculty-card">
          <h5 className="mb-3 innerheader-new">
            <span> Committee Recommendations</span>
          </h5>

          <FormikProvider value={formik}>
            <Form onSubmit={formik.handleSubmit}>
              {trustData?.length > 0 ? (
                <>
                  <div className="table-responsive mt-3">
                    <table className="table table-bordered">
                      <thead className="table-primary">
                        <tr>
                          <th>S.No</th>
                          <th>Institution Code</th>
                          <th>Name of the Institution</th>
                          <th>
                            {" "}
                            Name and Address of the Current Trust/ Society{" "}
                          </th>
                          <th>
                            {" "}
                            Name and Address of the New/ Proposed Trust/
                            Society{" "}
                          </th>
                          <th> Recommended (Yes / No) </th>
                        </tr>
                      </thead>
                      <tbody>
                        {trustData.map((item, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{item.coll_code}</td>
                            <td>{item.inst_name}</td>
                            <td>

                              {item.current_name_of_trust}  &emsp;-
                              {item.current_address}


                            </td>
                            <td>

                              {item.proposed_new_name}  &emsp;-
                              {item.new_address}
                            </td>
                            {/* Radio */}
                            <td
                              className="text-center align-middle"
                              style={{ verticalAlign: "middle" }}
                            >
                              <div className="d-flex justify-content-center align-items-center">
                                <label className="me-3 mb-0 d-flex align-items-center">
                                  <Field
                                    type="radio"
                                    name="recommended"
                                    value="YES"
                                    className="form-check-input me-1 mt-0"
                                    disabled={["yes", "no"].includes(
                                      item.recommended_status?.toLowerCase(),
                                    )}
                                  />
                                  <span>Yes</span>
                                </label>

                                <label className="mb-0 d-flex align-items-center">
                                  <Field
                                    type="radio"
                                    name="recommended"
                                    value="NO"
                                    className="form-check-input me-1 mt-0"
                                    disabled={["yes", "no"].includes(
                                      item.recommended_status?.toLowerCase(),
                                    )}
                                  />
                                  <span>No</span>
                                </label>
                              </div>

                              <ErrorMessage
                                name="recommended"
                                component="div"
                                className="text-danger text-center mt-1"
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  {/* Submit */}
                 {["YES", "NO"].includes(
  trustData?.[0]?.recommended_status
) ? (

  <div className="d-flex justify-content-end mt-3">
    <span className="text-success fw-bold">
      Already Submitted
    </span>
  </div>

) : (

  <div className="d-flex justify-content-end mt-3">
    <button type="submit" className="btn btn-primary">
      Submit
    </button>
  </div>

)}
                </>
              ) : (
                <div className="text-center text-danger fw-bold fs-6">
                  **** No Data Found ****
                </div>
              )}
            </Form>
          </FormikProvider>
        </div>
      </div>
    </>
  );
}
